import React from 'react';

const STATUS_LABELS = {
  active: 'Brief Ready',
  posted: 'Posted',
  verified: 'Verified',
  paid: 'Paid',
  pending: 'Pending',
  upcoming: 'Not Started',
  briefing: 'Brief Sent',
};

export default function StatusBadge({ status }) {
  const label = STATUS_LABELS[status] || status;
  return <span className={`camp-stage ${status}`}>{label}</span>;
}
